module.exports = __webpack_public_path__ + "img/Mehr_Iran.267802a0.svg";